import React, { useEffect, useState } from 'react';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { API } from '@src/api';
import { memberInContextAtom, identifiedNeedsAtom } from '@src/global-state';
import { useAtom } from 'jotai';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { trimZipcodeToFiveDigits } from '@repo/utils';
import { updateDeclinedScreener } from '@src/utills/storage';

export const Home = ({ isOpen, onClose }) => {
  const [memberInContext, setMemberInContext] = useAtom(memberInContextAtom);
  const [identifiedNeeds, setIdentifiedNeeds] = useAtom(identifiedNeedsAtom);
  const { navigate } = useRouter();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const form = useForm();
  const onSubmit = (data) => {
  };

  useEffect(() => {
    const data = form.getValues();
    if (data.option) {
      setIsDisabled(false);
    }
  }, [form]);

  const onContinue = async () => {
    setIsLoading(true);
    const data = form.getValues();
    onClose();
    onClose();
    const payload = {
      memberId: memberInContext?.member_id,
      zipCode: memberInContext?.addrZipCode,
      reason: data.option,
    };
    updateDeclinedScreener(memberInContext?.member_id);
    await API.skipAssessment(payload).then(
      // eslint-disable-next-line @typescript-eslint/no-shadow
      async (data: any) => {
      },
      (err) => {
      }
    );
    setIsLoading(false);
    setIdentifiedNeeds(null);
    navigate(
      `/search?zipcode=${trimZipcodeToFiveDigits(
        memberInContext?.addrZipCode ?? ''
      )}`
    );
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div
          style={{
            zIndex: 999,
            backgroundColor: '#FFFFFF',
            opacity: 0.75,
            position: 'fixed',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            margin: 0,
            top: 0,
            left: 0,
          }}
        >
          <LoadingSpinner
            size="xl"
            isLoading={isLoading}
            ariaLoadingLabel="Downloading files"
          />
        </div>
      ) : (
        ''
      )}
      <FormProvider state={form} onSubmit={onSubmit}>
        {/* Skip assesment modal */}
        <ModalDialog
          isOpen={isOpen}
          onClose={onClose}
          header="Please help us understand why you will not be taking the needs screener."
          model="title-aligment"
          size="$md"
        >
          <div>
            <RadioGroup label="" model="option">
              <RadioGroup.Column>
              <RadioGroup.Radio
                label="Member has already taken a screener in the last 12 months."
                value="Member has already taken a screener in the last 12 months."
              />
              <RadioGroup.Radio
                label="I already understand the members needs today."
                value="I already understand the members needs today."
              />
              <RadioGroup.Radio
                label="The member declined to take the needs screener today."
                value="The member declined to take the needs screener today."
              />
              </RadioGroup.Column>
            </RadioGroup>
          </div>
          <div>
            <Layout.Group alignLayout="right" style={{ paddingBottom: '19px' }}>
              <Button
                variant="outline"
                style={{ width: '100%' }}
                onClick={onClose}
                aria-describedby="Please select option"
              >
                Go back
              </Button>
              <Button
                type="submit"
                style={{ width: '100%' }}
                onClick={onContinue}
                isDisabled={isDisabled}
                aria-describedby="Please select option"
              >
                Continue
              </Button>
            </Layout.Group>
          </div>
        </ModalDialog>
        {/* Skip assesment modal end */}
      </FormProvider>
    </React.Fragment>
  );
};
